<template>
  <div class="py-6 px-8">
    <h-header back="../transfers">
      <template v-slot:actions>
        <v-btn @click="bulkTransfer()" v-if="isNotCompletedOrInProcess" class="primary" elevation="0">
          {{ $t('transfer.label.executeTransfer') }}
        </v-btn>
      </template>
    </h-header>

    <h-loading v-if="isLoading" />

    <v-card v-if="!isLoading && transfer" elevation="0" class="pb-5" outlined>
      <TransferData :transfer="transfer" />
      <TransferInvoices v-if="hasInvoices" @showHost="showHost" :transfer="transfer" />
      <TransferPayments v-else :transfer="transfer" />
      <TransferHistory :transfer="transfer" />
    </v-card>

    <TransferConfirmModal
      :parsedTransfers="parsedTransfers"
      :selectedTransfers="selectedTransfers"
    />

    <RightDrawer :moreInfo="false">
      <HostSummary :data="host" />
    </RightDrawer>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { catalogMonetary } from '@/util/catalog'

import TransferData from '@/components/transfer/TransferData'
import TransferPayments from '@/components/transfer/TransferPayments'
import TransferHistory from '@/components/transfer/TransferHistory'
import TransferInvoices from '@/components/transfer/TransferInvoices'
import TransferConfirmModal from '@/components/transfer/modal/TransferConfirmModal'

import RightDrawer from '@/components/app/RightDrawer'
import HostSummary from '@/components/host/HostSummary'

export default {
  name: 'TransferDetails',

  components: {
    TransferData,
    TransferPayments,
    TransferHistory,
    TransferInvoices,
    TransferConfirmModal,

    RightDrawer,
    HostSummary,
  },

  data() {
    return {
      id: this.$router.currentRoute.params.id,
      parsedTransfers: [],
      selectedTransfers: [],
      formatMoney: catalogMonetary,
    }
  },

  computed: {
    ...mapGetters(['isLoading', 'transfer', 'host']),

    isNotCompletedOrInProcess() {
      return this.transfer ? ['CANCELED', 'FAILED', 'PENDING'].includes(this.transfer.status) : false
    },

    invoices() {
      return this.transfer?.invoices ?? []
    },

    hasInvoices() {
      return this.invoices?.length > 0
    },
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),
    ...mapActions(['fetchTransfer', 'openModal', 'fetchHost']),

    bulkTransfer() {
      this.selectedTransfers = [this.transfer]
      this.parsedTransfers = [this.id]
      this.$nextTick(() => this.openModal('TRANSFER_CONFIRM_MODAL'))
    },

    resetSelected() {
      this.parsedTransfers = []
      this.selectedTransfers = []
    },

    getNames(item) {
      switch(item?.receiver_type) {
        case('HOST'):
          return item?.host?.name
        case('VENDOR'):
          return item?.vendor?.name
        case('PARTNER'):
          return item?.partner?.name
        default:
          return '---'
      }
    },

    showHost(id) {
      this.setIsDrawerOpen()
      this.fetchHost(id, false)
    },
  },

  async mounted() {
    await this.fetchTransfer(this.id)
  },
}
</script>
